// extracted by mini-css-extract-plugin
export default {"content":"yflPd0zm","description":"KH236kiH"};